import globalConfig from '../../utiles/globalConfig';

const page = {
  selectGamePage: 'select-login-game-page',
  accountLoginPage: 'account-login-page',
  thirdLoginPage: 'third-login-page',
  registerPage: 'account-register-page',
};

export default {
  event: {
    'j-show-all-game': [
      {
        type: 'click',
        event: 'click-show-all-game-btn',
        pageName: page.selectGamePage,
      },
    ],
    'j-back-game-list': [
      {
        type: 'click',
        event: 'click-back-game-list-btn',
      },
    ],
    'j-select-game': [
      {
        type: 'click',
        event: 'click-update-game',
        pageName: page.selectGamePage,
      },
    ],
    'j-facebook-login-btn': [
      {
        type: 'click',
        event: 'click-facebook-login-btn',
        newPage: true,
      },
    ],
    'j-twitter-login-btn': [
      {
        type: 'click',
        event: 'click-twitter-login-btn',
        newPage: true,
      },
    ],
    'j-googleplay-login-btn': [
      {
        type: 'click',
        event: 'click-google-login-btn',
        newPage: true,
      },
    ],
    'j-account-info': [
      {
        type: 'click',
        event: 'click-account-info-btn',
        pageName: page.thirdLoginPage,
      },
    ],
    'j-lang-select-ele': [
      {
        type: 'change',
        event: 'click-update-lang',
      },
      {
        type: 'focus',
        event: 'click-open-lang-list',
      },
    ],
    'j-switch-regist': [
      {
        type: 'click',
        event: 'click-goto-register-page',
        pageName: page.accountLoginPage,
      },
    ],
    'j-switch-login': [
      {
        type: 'click',
        event: 'click-goto-login-page',
        pageName: page.registerPage,
      },
    ],
    'j-login-btn': [
      {
        type: 'click',
        event: 'click-account-login-btn',
        pageName: page.accountLoginPage,
      },
    ],
    'j-register-btn': [
      {
        type: 'click',
        event: 'click-account-register-btn',
        pageName: page.registerPage,
      },
    ],
  },
  enter: {
    selectGamePage: {
      event: globalConfig.getHrefParamUndecode('gameId')
        ? ''
        : page.selectGamePage,
    },
    accountLoginPage: { event: page.accountLoginPage },
    thirdLoginPage: { event: page.thirdLoginPage },
    registerPage: { event: page.registerPage },
  },
};
